
const state = {
    employments: [],
    employment: {id: null}
}

export default state
